import * as React from 'react';
import type { SVGProps } from 'react';
const SvgCommand = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 24 24" {...props}>
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M4.75 6.5a1.75 1.75 0 1 1 3.5 0v1.75H6.5A1.75 1.75 0 0 1 4.75 6.5M15.75 6.5a1.75 1.75 0 1 1 1.75 1.75h-1.75zM15.75 15.75h1.75a1.75 1.75 0 1 1-1.75 1.75zM4.75 17.5c0-.966.784-1.75 1.75-1.75h1.75v1.75a1.75 1.75 0 1 1-3.5 0M8.25 8.25h7.5v7.5h-7.5z"
    />
  </svg>
);
export default SvgCommand;
